export { default } from 'mapbox-gl';
//# sourceMappingURL=mapboxgl.browser.js.map